import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

const namespace = 'features';
export const keyPrefix = 'attach_department_users';
export const useAttachDepartmentUsersTranslation = (): UseTranslationResponse<typeof namespace, typeof keyPrefix> => {
  return useTranslation(namespace, { keyPrefix });
};

export const ruRu = ({
  [keyPrefix]: {
    title: 'Добавить',
    search_placeholder: 'Поиск',
    loading: 'Загрузка',
    empty: 'Нет доступных пользователей',
    load_error: 'Не удалось загрузить пользователей',
    on_success: 'Пользователь прикреплён',
    on_error: 'Не удалось прикрепить пользователя',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    title: 'Add',
    search_placeholder: 'Search',
    loading: 'Loading',
    empty: 'No users available',
    load_error: 'Failed to load users',
    on_success: 'User attached',
    on_error: 'Failed to attach user',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    title: 'Agregar',
    search_placeholder: 'Buscar',
    loading: 'Cargando',
    empty: 'No hay usuarios disponibles',
    load_error: 'No se pudieron cargar los usuarios',
    on_success: 'Usuario adjuntado',
    on_error: 'No se pudo adjuntar el usuario',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    title: 'Adicionar',
    search_placeholder: 'Pesquisar',
    loading: 'Carregando',
    empty: 'Nenhum usuário disponível',
    load_error: 'Falha ao carregar os usuários',
    on_success: 'Usuário anexado',
    on_error: 'Falha ao anexar o usuário',
  },
}) as Record<string, unknown>;
